import { post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';
const url = 'api/confirmAddrPhoneEmail';

export function postCheck(data) {
    return post(`${url}/check`, data);
}
export function postMemberVerifySubmit(data) {
    return post(`${url}/memberVerifySubmit`, data, { ...options, closeAlert: true });
}
